import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-1.5" }
const _hoisted_2 = { class: "block text-sm font-bold text-slate-700 capitalize" }
const _hoisted_3 = ["required", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? '*' : ''), 1),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "block w-full px-4 py-2.5 text-sm font-medium text-slate-900 bg-white border border-[#8c8c94] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all placeholder:text-slate-400",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      required: _ctx.required,
      placeholder: `Masukkan ${_ctx.label.toLowerCase()}...`,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
    }, null, 40, _hoisted_3), [
      [_vModelText, _ctx.inputValue]
    ])
  ]))
}